<script setup lang="ts">
import type { CondominiumInfoProps } from '.';

import TextLink from '~/components/ui/text-link/TextLink.vue';

defineProps<CondominiumInfoProps>();
</script>

<template>
	<div class="flex w-full items-start gap-2 p-2 md:gap-3">
		<div class="flex size-5 shrink-0 items-start justify-center">
			<slot name="icon" />
		</div>
		<div class="flex flex-col items-start gap-0">
			<p
				class="font-sans text-xs font-normal leading-[150%] text-primary-light-3"
			>
				{{ title }}
			</p>
			<NuxtLink :to="linkTo">
				<TextLink class="text-sm font-medium leading-5 text-primary">
					{{ name }}
				</TextLink>
			</NuxtLink>
		</div>
	</div>
</template>
